/**
 * @generated SignedSource<<e33ee3ab50742457da71aa240b10c26c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTopicsListItem_orgTopic$data = {
  readonly description: string | null;
  readonly isDefault: boolean;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentType": "OrgAdminTopicsListItem_orgTopic";
};
export type OrgAdminTopicsListItem_orgTopic$key = {
  readonly " $data"?: OrgAdminTopicsListItem_orgTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgAdminTopicsListItem_orgTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgAdminTopicsListItem_orgTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "631fc5dda14aaf5ac8421936b747abb5";

export default node;
